import { useQuery } from '@tanstack/react-query'
import { Button } from '@/components/ui/button'
import { Drawer, DrawerSection, DrawerDetailRow, DrawerFooter } from '@/components/ui/drawer'
import { getCounterById } from '@/api/counters.api'
import type { Counter } from '@/types/api'

interface CounterDetailDrawerProps {
    counterId: string | null
    showUnitColumn?: boolean
    onClose: () => void
    onUpdate?: (counter: Counter) => void
}

export function CounterDetailDrawer({ counterId, showUnitColumn, onClose, onUpdate }: CounterDetailDrawerProps) {
    const { data: counter, isLoading } = useQuery({
        queryKey: ['counter-detail', counterId],
        queryFn: ({ signal }) => counterId ? getCounterById(counterId, signal) : Promise.resolve(null),
        enabled: !!counterId,
        refetchOnMount: 'always',
        staleTime: 0,
        gcTime: 0,
    })

    return (
        <Drawer
            open={!!counterId}
            onClose={onClose}
            title="CHI TIẾT QUẦY"
            styles={{ body: { overflow: 'auto' } }}
            footer={
                <DrawerFooter>
                    <Button variant="outline" size="md" onClick={onClose} className="min-w-[160px] h-10">Đóng</Button>
                    <Button variant="primary" size="md" onClick={() => counter && onUpdate?.(counter)} disabled={!counter || isLoading} className="min-w-[160px] h-10">Cập nhật</Button>
                </DrawerFooter>
            }
        >
            {isLoading && <div className="p-6 text-center text-gray-500">Đang tải chi tiết...</div>}
            {counter && (
                <div>
                    <DrawerSection title="Thông tin chung" bodyClassName="pb-3">
                        <DrawerDetailRow label="Số quầy:" value={counter.deskNumber ? String(counter.deskNumber).padStart(2, '0') : '-'} />
                        <DrawerDetailRow label="Tên quầy:" value={counter.name || '-'} />
                        {showUnitColumn && <DrawerDetailRow label="Đơn vị:" value={counter.unitName || '-'} />}
                        <DrawerDetailRow label="Sơ đồ:" value={counter.diagramName || '-'} />
                        <DrawerDetailRow
                            label="Trạng thái:"
                            value={
                                <span className={`px-4 py-1.5 rounded-full text-xs font-semibold ${counter.status === 1 ? 'bg-[#EAF7ED] text-[#2FB14F]' : 'bg-[#FDECEB] text-[#EE4036]'}`}>
                                    {counter.status === 1 ? 'Hoạt động' : 'Không hoạt động'}
                                </span>
                            }
                        />
                    </DrawerSection>
                </div>
            )}
        </Drawer>
    )
}
